// Unified operator Inbox — surfaces HITL pauses + open Signals as
// sibling rows on one stream so the operator triages both from one place.
// (DEV-16228 / DEV-16215.)
import { z } from 'zod';
import { HitlQueueItemSchema } from './run.js';
import { SignalSummarySchema } from './signal.js';
/**
 * One Inbox row, discriminated by `type`. The shape on the wire is
 * intentionally `{ type, ...row }` — flat fields after the discriminator
 * so a UI can render a row without remembering to drill into a nested
 * `payload`. Each variant inherits its full schema so callers get end-
 * to-end type safety on the union.
 */
export const InboxHitlRowSchema = z.object({ type: z.literal('hitl') }).and(HitlQueueItemSchema);
export const InboxSignalRowSchema = z
    .object({ type: z.literal('signal') })
    .and(SignalSummarySchema);
export const InboxRowSchema = z.union([InboxHitlRowSchema, InboxSignalRowSchema]);
//# sourceMappingURL=inbox.js.map